export const FILE_SIZE_1 = 1024 * 1024 * 10
export const FILE_SIZE_2 = 1024 * 1024 * 500
